var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var OriginModel_1;
/* eslint-disable import/no-duplicates */
import '@symon-ai/wisepipe-common'; // force import for JsonSchemaV2
import { S3File, Utils } from '@symon-ai/wisepipe-common';
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './importConfigs/importConfig'; // force import for JsonSchemaV2
import { ImportConfigType } from './importConfigs/importConfig';
import { Origin } from './origin';
import { originModelSchemaValidation } from '../validations.generated';
export const originModelSchema = {
    $id: 'urn:wisepipe-common-data:OriginModel',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        s3Folder: { $ref: 'urn:wisepipe-common:S3File' },
        discoveryID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        connectionID: { type: 'string', uid: 9 },
        hidden: { type: 'boolean' }
    },
    required: ['orgID', 'originID', 'name', 'config', 's3Folder']
};
let OriginModel = OriginModel_1 = class OriginModel {
    constructor(orgID, originID, name, config, s3Folder, discoveryID, streamID, connectionID, transient = false, hidden) {
        // I don't think this logic can be expressed using JSON Schema
        // transient uses originmodel to do csvextraction, and has no streamid associated
        if (!transient &&
            config.importConfigType !== ImportConfigType.Excel &&
            config.importConfigType !== ImportConfigType.S3Csv &&
            config.importConfigType !== ImportConfigType.Sftp &&
            config.importConfigType !== ImportConfigType.Fwf &&
            config.importConfigType !== ImportConfigType.OneDrive &&
            config.importConfigType !== ImportConfigType.EltApi &&
            config.needsDiscovery) {
            if (!discoveryID)
                throw new Error("The field 'discoveryID' is required.");
            if (!streamID)
                throw new Error("The field 'streamID' is required.");
            // Include once OriginModels with Connection v1 are obsolete
            // if (!connectionID) throw new Error("The field 'connectionID' is required.")
        }
        this.orgID = orgID;
        this.originID = originID;
        this.name = name;
        this.config = config;
        this.s3Folder = s3Folder;
        // Discovery
        this.discoveryID = discoveryID;
        this.streamID = streamID;
        this.connectionID = connectionID;
        this.hidden = hidden ?? false;
        JSON.validate(this, OriginModel_1);
    }
    get bufferID() {
        return OriginModel_1.bufferID(this.originID);
    }
    toOrigin(dataSources) {
        return new Origin(this.orgID, this.originID, this.name, dataSources, this.config, this.discoveryID, this.streamID, this.connectionID, this.hidden);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(originID) {
        return Utils.base64StringToBuffer(originID);
    }
    get originModelS3Path() {
        return new S3File(this.s3Folder.bucket, `${this.s3Folder.key}/originModel.json`);
    }
};
OriginModel = OriginModel_1 = __decorate([
    JsonSchemaV2(originModelSchema, originModelSchemaValidation)
], OriginModel);
export { OriginModel };
//# sourceMappingURL=originModel.js.map